export default __webpack_public_path__ + "3d14978e7b83e5a86bfbe392f5e528c2.svg";